<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" [style]="{ color: color }">
  <rect x="0" y="5" width="4" height="14" />
  <rect x="5" y="1" width="12" height="22" />
  <rect x="18" y="5" width="4" height="14" />
</svg>
